import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import WkcPurchaseApplicationDetails from '@/types/table/wkcPurchaseApplicationDetails';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface WkcPurchaseApplicationDetailsData extends WkcPurchaseApplicationDetails {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class WkcPurchaseApplicationDetailsController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<WkcPurchaseApplicationDetailsData>>(API_CONTEXT + '/app/wkcPurchaseApplicationDetails/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<WkcPurchaseApplicationDetailsData>(API_CONTEXT + '/app/wkcPurchaseApplicationDetails/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/wkcPurchaseApplicationDetails/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/wkcPurchaseApplicationDetails/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/wkcPurchaseApplicationDetails/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcPurchaseApplicationDetails/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcPurchaseApplicationDetails/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcPurchaseApplicationDetails/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcPurchaseApplicationDetails/deleteBatch', params, httpOptions);
  }

  static listList(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<WkcPurchaseApplicationDetailsData>>(API_CONTEXT + '/app/wkcPurchaseApplicationDetails/listList', params, httpOptions);
  }


}
